// Queue Services Action Types
export const CREATE_QUEUE_RECORD = "CREATE_QUEUE_RECORD";
export const CREATE_QUEUE_RECORD_SUCCESS = "CREATE_QUEUE_RECORD_SUCCESS";
export const CREATE_QUEUE_RECORD_FAILURE = "CREATE_QUEUE_RECORD_FAILURE";

export const UPDATE_QUEUE_RECORD = "UPDATE_QUEUE_RECORD";
export const UPDATE_QUEUE_RECORD_SUCCESS = "UPDATE_QUEUE_RECORD_SUCCESS";
export const UPDATE_QUEUE_RECORD_FAILURE = "UPDATE_QUEUE_RECORD_FAILURE";

export const DELETE_QUEUE_RECORD = "DELETE_QUEUE_RECORD";
export const DELETE_QUEUE_RECORD_SUCCESS = "DELETE_QUEUE_RECORD_SUCCESS";
export const DELETE_QUEUE_RECORD_FAILURE = "DELETE_QUEUE_RECORD_FAILURE";

export const GET_QUEUE_RECORD = "GET_QUEUE_RECORD";
export const GET_QUEUE_RECORD_SUCCESS = "GET_QUEUE_RECORD_SUCCESS";
export const GET_QUEUE_RECORD_FAILURE = "GET_QUEUE_RECORD_FAILURE";

export const LIST_QUEUE_RECORDS = "LIST_QUEUE_RECORDS";
export const LIST_QUEUE_RECORDS_SUCCESS = "LIST_QUEUE_RECORDS_SUCCESS";
export const LIST_QUEUE_RECORDS_FAILURE = "LIST_QUEUE_RECORDS_FAILURE";

// Queue Services Action Creators

// Create a new queue record
export const createQueueRecord = (queueRecordInput) => ({
  type: CREATE_QUEUE_RECORD,
  payload: queueRecordInput,
});

// Successful queue record creation
export const createQueueRecordSuccess = (response) => ({
  type: CREATE_QUEUE_RECORD_SUCCESS,
  payload: response,
});

// Queue record creation failure
export const createQueueRecordFailure = (error) => ({
  type: CREATE_QUEUE_RECORD_FAILURE,
  error,
});

// Update an existing queue record
export const updateQueueRecord = (queueRecordInput) => ({
  type: UPDATE_QUEUE_RECORD,
  payload: queueRecordInput,
});

// Successful queue record update
export const updateQueueRecordSuccess = (response) => ({
  type: UPDATE_QUEUE_RECORD_SUCCESS,
  payload: response,
});

// Queue record update failure
export const updateQueueRecordFailure = (error) => ({
  type: UPDATE_QUEUE_RECORD_FAILURE,
  error,
});

// Delete a queue record
export const deleteQueueRecord = (id) => ({
  type: DELETE_QUEUE_RECORD,
  payload: { id },
});

// Successful queue record deletion
export const deleteQueueRecordSuccess = (response) => ({
  type: DELETE_QUEUE_RECORD_SUCCESS,
  payload: response,
});

// Queue record deletion failure
export const deleteQueueRecordFailure = (error) => ({
  type: DELETE_QUEUE_RECORD_FAILURE,
  error,
});

// Retrieve a single queue record
export const getQueueRecord = (id) => ({
  type: GET_QUEUE_RECORD,
  payload: { id },
});

// Successful queue record retrieval
export const getQueueRecordSuccess = (queueRecord) => ({
  type: GET_QUEUE_RECORD_SUCCESS,
  payload: queueRecord,
});

// Queue record retrieval failure
export const getQueueRecordFailure = (error) => ({
  type: GET_QUEUE_RECORD_FAILURE,
  error,
});

// List queue records
export const listQueueRecords = (limit, nextToken) => ({
  type: LIST_QUEUE_RECORDS,
  payload: { limit, nextToken },
});

// Successful queue records listing
export const listQueueRecordsSuccess = (queueRecordsConnection) => ({
  type: LIST_QUEUE_RECORDS_SUCCESS,
  payload: queueRecordsConnection,
});

// Queue records listing failure
export const listQueueRecordsFailure = (error) => ({
  type: LIST_QUEUE_RECORDS_FAILURE,
  error,
});
